import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { catchError, firstValueFrom, of } from 'rxjs';

import { ValidationService } from '../../../utils/valibot/validation.service';
import { CustomerInsights, CustomerInsightsSchema } from '../../model/insights';

@Injectable({
  providedIn: 'root',
})
export class CdhTwinClient {
  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);
  private readonly validationService = inject(ValidationService);

  getCustomerInsights(gcid: string): Promise<CustomerInsights | null> {
    const url = `insights/${gcid}`;
    this.logger.info(`Fetching for addresses ${url}`);
    return firstValueFrom(
      this.http.get(url).pipe(
        this.validationService.pipeResponse(CustomerInsightsSchema),
        catchError((errorResponse: unknown) => {
          this.logger.error(`Error fetching additional customer data`, errorResponse);
          return of(null);
        }),
      ),
    );
  }
}
